/* eslint-disable */
import React , { useState, useEffect } from 'react';
// css
import './App.scss';
import './css/setting.scss';
import './css/mobile.scss';
// Typescript에서는 import할때 확장명을 지우고 작성해야 한다.
// components
import Header from './components/header';
import Intro from './components/intro';
import Skill from './components/skill';
import Portfoilo from './components/portfoilo';
import Footer from './components/footer';

function App() {  

  useEffect(() => {
    // 네비게이션의 정보 가져오기
    let menu : any = document.querySelectorAll('header ul li');
    // 네비게이션의 'data-scroll'값 가져오기
    for (let i = 0; i < menu.length; i++) {
      // 어디로 이동할지 스크롤 값 가져오기
      let section : any = document.querySelectorAll('section');
      // 누르면 해당 영역으로 스크롤 한다.
      menu[i].addEventListener('click', () => { 
        // 속성값 가져오기
        const attr : any = menu[i].getAttribute('data-scroll');
        if (section[i].classList.contains(attr)) {
          // 스크롤 이동
          const height = section[i].offsetTop;
          // Home은 가장 상단으로 이동해야 한다.
          if (section[i].classList.contains('intro')) { window.scrollTo(0, 0); }
          else { window.scrollTo(0, height); }
        } else { return false; }
      })
      // 스크롤 위치에 따라 메뉴 색상이 다르게 하기
      window.addEventListener('scroll', () => {
        if (window.scrollY >= 0 && window.scrollY < section[1].offsetTop) {
          // 스크롤 영역이 인트로
          menu[i].classList.remove('active');
          menu[0].classList.add('active');
        } else if (window.scrollY >= section[1].offsetTop && window.scrollY < section[2].offsetTop) {
          // 스크롤 영역이 스킬
          menu[i].classList.remove('active');
          menu[1].classList.add('active');
        } else if (window.scrollY >= section[2].offsetTop && window.scrollY < (section[2].offsetTop + section[2].offsetHeight)) {
          // 스크롤 영역이 포트폴리오
          menu[i].classList.remove('active');
          menu[2].classList.add('active');
        } else {
          // 아무곳도 아닐 때
          menu[i].classList.remove('active');
        }
      })
    }
  }, []);

  return (
    <div className="App">
      <Header /> {/* Header */}
      <main>
        <Intro /> {/* Intro */}
        <Skill /> {/* Skill */}
        <Portfoilo /> {/* Portfoilo */}
        <Footer /> {/* Footer */}
      </main>
    </div>
  );
}

export default App;
